import { FetchEmpCategory } from '../../actions';
import { connect } from 'react-redux';
import react from 'react'
import { ServicePlaceHolder } from '../utils/ImagePlaceholder'
import  ServiceItem from './ServiceItem'
import { BASE_URL } from '../../variables'
const ServiceBox = (props) => {
    react.useEffect(() => {
        props.FetchEmpCategory()
    }, [])

    const renderServices = props?.services?.data?.map((service) => {
        return <ServiceItem service={service} baseUrl={BASE_URL} key={service.id}/>
    })

    console.log(props.services.loading)
    
    return(
        <div className={`service-box-container ${props.mobileNav ? "" : "ui container"}`}>
            <div className="adjustment">
                <div className="service-inner-container">
                    {!props.services.loading ? renderServices : <ServicePlaceHolder width="100%" height="100%"/>}
                </div>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        services : state.EmployeeCategory,
        mobileNav: state.mobileNav
    }
}

export default connect(mapStateToProps, {  FetchEmpCategory })(ServiceBox);


/* <Link key={service.id} className="service-item" to={`/services/${service.slug}`}>
<div className="service-icon">
    <img src={`${BASE_URL}${service.icon}`} alt={service.slug} className="service-img" />
</div>
<div>{service.name}</div>
</Link> */